import { useClientPortalAPI } from "@certn/api/src/useClientPortalAPI";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";
import { useUser } from "../../../hooks/useUser";
import { sortPickerItems } from "../../../utils/sortPickerItems";

export function RequestorFilter() {
  const { setParam, params } = useQueryParams();
  const { details: userDetails } = useUser();
  const { t } = useTranslation();

  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/apply-links/requestors/options/"
  );

  return (
    <Picker
      isLoading={isLoading}
      label={t("Requestor")}
      showActionBar
      selectionMode="multiple"
      selectedKeys={params.requestor?.split(",") || []}
      onSelectionChange={(keys) => setParam("requestor", Array.from(keys))}
      items={sortPickerItems({
        data,
        userDetails,
        includeAvatar: true,
        useIdAsKey: false,
        t,
      })}
      testID="apply-link-requestor-filter"
    />
  );
}
